import React from 'react';
import {
  IconShedFilled,
  IconGarageFilled,
  IconPorch,
  IconOthersFilled,
} from 'wg-fe-ui';

interface Props {
  type?: string;
  color?: string;
}

const AnnexesIconSelector: React.FC<React.PropsWithChildren<Props>> = ({
  type,
  color = 'black',
}) => {
  switch (type?.toLowerCase()) {
    case 'garden_shed':
      return <IconShedFilled color={color} />;
    case 'carport':
      return <IconGarageFilled color={color} />;
    case 'gazebo':
      return <IconPorch color={color} />;
    case 'other':
      return <IconOthersFilled color={color} />;
    default:
      return <IconOthersFilled color={color} />;
  }
};

export default AnnexesIconSelector;
